import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Pagination from '@mui/material/Pagination';
import Select from '@mui/material/Select';
import {styled, useTheme} from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';

import {pxToRem} from '../../utils';
import Legend from '../Legend/Legend';

const StyledPaginationDiv = styled('div')(({theme}) => ({
  marginTop: '5px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  '& button': {
    margin: '0 5px',
  },
}));

const StyledSelect = styled(Select)(({theme}) => ({
  marginRight: pxToRem(8),
  boxShadow: 'none',
  '.MuiOutlinedInput-notchedOutline': {border: 0},
}));

const CustomTablePagination = ({totalcount, tableInstance, setPagination, pageSize, pageSizeOptions, globalFilter}) => {
  const theme = useTheme();

  const pageSizes = pageSizeOptions ? pageSizeOptions : [1000, 2000, 5000];

  const onPageSizeChange = (event) => {
    setPagination((prevState) => ({
      ...prevState,
      pageSize: event.target.value,
    }));
    tableInstance.setPageSize(event.target.value);
    tableInstance.setPageIndex(0);
  };

  return (
    <StyledPaginationDiv>
      <Legend
        label={'Total:'}
        data={globalFilter ? tableInstance.getFilteredRowModel().rows.length : totalcount}
        textColor={theme.palette.primary.dark}
      />
      <Box
        sx={{
          display: 'flex',
          alignItems: 'baseline',
        }}
      >
        <Typography sx={{marginRight: pxToRem(8)}}>Rows per page</Typography>
        <StyledSelect size="small" value={pageSize} onChange={onPageSizeChange}>
          {pageSizes.map((item) => (
            <MenuItem key={item} value={item}>
              {item}
            </MenuItem>
          ))}
        </StyledSelect>
        <Pagination
          color="primary"
          page={tableInstance.getState().pagination.pageIndex + 1}
          count={tableInstance.getPageCount()}
          showFirstButton
          showLastButton
          boundaryCount={2}
          siblingCount={1}
          onChange={(event, value) => tableInstance.setPageIndex(value - 1)}
        />
      </Box>
    </StyledPaginationDiv>
  );
};

export default CustomTablePagination;
